module.exports = __webpack_public_path__ + "img/arrow_back_icon.69b44bc0.svg";